// ===============================
// Community banner video autoplay
// Deferred until after window.load so the 6 MB video doesn't compete
// with LCP resources during page load. CSS aspect-ratio:16/9 reserves
// the space so no CLS occurs while the video is pending.
// ===============================
(function () {
  function initCommunityBannerVideo() {
    var video = document.querySelector('.banner--community .community-banner-video');
    if (!video) return;

    // Load the video src now (browser starts buffering only at this point)
    var dataSrc = video.getAttribute('data-src');
    if (dataSrc && !video.src) {
      video.src = dataSrc;
    }

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    function attemptPlay() {
      if (video.paused) {
        video.play().catch(function () {});
      }
    }

    ['loadeddata', 'canplay'].forEach(function (eventName) {
      video.addEventListener(eventName, attemptPlay, { once: true });
    });

    video.load();

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && video.paused) {
        attemptPlay();
      }
    });

    // Pause when scrolled off-screen to reduce mobile CPU/GPU usage
    if ('IntersectionObserver' in window) {
      var viewObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          if (video.paused) video.play().catch(function () {});
        } else {
          if (!video.paused) video.pause();
        }
      }, { threshold: 0.1 });
      viewObserver.observe(video);
    }
  }

  // Fire after window.load so the video download doesn't block LCP.
  // requestIdleCallback ensures the main thread is free before we start.
  function scheduleVideoInit() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initCommunityBannerVideo, { timeout: 3000 });
    } else {
      setTimeout(initCommunityBannerVideo, 500);
    }
  }

  if (document.readyState === 'complete') {
    scheduleVideoInit();
  } else {
    window.addEventListener('load', scheduleVideoInit);
  }
})();

// ===============================
// Community Slider
// ===============================
document.addEventListener('DOMContentLoaded', function () {
  function getSplideSlideCount(splideInstance) {
    if (!splideInstance || !splideInstance.Components) return 0;
    const slidesComponent = splideInstance.Components.Slides;
    if (!slidesComponent) return 0;
    if (typeof slidesComponent.getLength === 'function') {
      return slidesComponent.getLength();
    }
    if (typeof slidesComponent.getSlides === 'function') {
      return slidesComponent.getSlides().length;
    }
    if (splideInstance.root) {
      return splideInstance.root.querySelectorAll('.splide__slide:not(.splide__slide--clone)').length;
    }
    return 0;
  }

  // Collaboration / connect sliders are below the fold — defer init until near-viewport.
  const collaborationSliders = document.querySelectorAll('.collaboration-slider');
  collaborationSliders.forEach((collaborationSlider) => {
    function mountCollabSlider() {
      new Splide(collaborationSlider, {
        type       : 'loop',
        drag       : 'free',
        arrows     : false,
        pagination : false,
        gap        : '20px',
        autoWidth  : true,
        autoScroll : {
          speed: 1,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      }).mount(window.splide.Extensions);
    }
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function(entries, obs) {
        if (entries[0].isIntersecting) {
          obs.disconnect();
          mountCollabSlider();
        }
      }, { rootMargin: '300px' });
      io.observe(collaborationSlider);
    } else {
      mountCollabSlider();
    }
  });

  // ===============================
  // Scroll to target functionality
  // ===============================
  // Delegate to capture clicks on nested elements (e.g., SVG inside the link)
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-scroll-target]');
    if (!trigger) return;

    const targetId = trigger.getAttribute('data-scroll-target');
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();

    if (typeof target.scrollIntoView === 'function') {
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      } catch (_) {
        // Fallback below
      }
    }

    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  });

  // ===============================
  // Tab Switching
  // ===============================
  const tabSection = document.querySelector('.community-tab-section');
  const tabWrapper = tabSection ? tabSection.querySelector('.tab-wrapper') : null;
  if (tabWrapper && tabSection) {
    const tabMenu = tabSection.querySelector('.tab-menu');
    const tabItems = tabWrapper.querySelectorAll('.tab-items');
    const tabButtons = tabMenu ? tabMenu.querySelectorAll('li') : [];

    if (tabMenu && tabItems.length && tabButtons.length) {
      // Store pageFlip instances
      const pageFlipInstances = {};

      function showTab(index) {
        // Hide all tabs
        tabItems.forEach(item => {
          item.style.display = 'none';
        });
        
        // Remove active class from all buttons
        tabButtons.forEach(btn => btn.classList.remove('tab-active'));

        // Show selected tab and activate button
        if (tabItems[index]) {
          tabItems[index].style.display = 'block';
          if (tabButtons[index]) {
            tabButtons[index].classList.add('tab-active');
            // Scroll active tab into view on mobile
            if (tabMenu && window.innerWidth <= 768) {
              tabButtons[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
          }
          
          // Initialize page flip for the active tab (desktop)
          initPageFlipForTab(tabItems[index], index);
          
          // Refresh mobile sliders when tab changes (on mobile)
          if (window.innerWidth <= 768) {
            setTimeout(() => {
              const slider1 = document.getElementById('communityMobileSlider1');
              const slider2 = document.getElementById('communityMobileSlider2');
              const slider3 = document.getElementById('communityMobileSlider3');
              
              if (index === 0 && slider1 && slider1.splideInstance) {
                // Refresh slider1 when tab 1 becomes active
                slider1.splideInstance.refresh();
              } else if (index === 1 && slider2) {
                // Initialize or refresh slider2 when tab 2 becomes active
                if (!slider2.splideInstance) {
                  // Initialize the slider
                  const splide2 = new Splide(slider2, {
                    type: 'slide',
                    perPage: 1.2,
                    perMove: 1,
                    arrows: false,
                    pagination: false,
                    gap: '4px',
                    focus: 'center',
                    trimSpace: false,
                  }).mount();
                  
                  slider2.splideInstance = splide2;
                  
                  // Setup arrows and pagination
                  const prevArrow2 = slider2.querySelector('.community-mobile-slider__arrow--prev');
                  const nextArrow2 = slider2.querySelector('.community-mobile-slider__arrow--next');
                  const paginationCurrent2 = slider2.querySelector('.community-mobile-slider__current');
                  const paginationTotal2 = slider2.querySelector('.community-mobile-slider__total');
                  
                  if (prevArrow2) {
                    prevArrow2.addEventListener('click', () => splide2.go('<'));
                  }
                  if (nextArrow2) {
                    nextArrow2.addEventListener('click', () => splide2.go('>'));
                  }
                  
                  if (paginationTotal2) {
                    const totalSlides = getSplideSlideCount(splide2);
                    paginationTotal2.textContent = String(totalSlides).padStart(2, '0');
                  }
                  
                  splide2.on('moved', (newIndex) => {
                    if (paginationCurrent2) {
                      const currentPage = String(newIndex + 1).padStart(2, '0');
                      paginationCurrent2.textContent = currentPage;
                    }
                    
                    if (prevArrow2) {
                      if (newIndex === 0) {
                        prevArrow2.classList.add('community-mobile-slider__arrow--disabled');
                      } else {
                        prevArrow2.classList.remove('community-mobile-slider__arrow--disabled');
                      }
                    }
                    if (nextArrow2) {
                      const totalSlides = getSplideSlideCount(splide2);
                      if (newIndex >= totalSlides - 1) {
                        nextArrow2.classList.add('community-mobile-slider__arrow--disabled');
                      } else {
                        nextArrow2.classList.remove('community-mobile-slider__arrow--disabled');
                      }
                    }
                  });
                } else {
                  // Refresh the slider if already initialized
                  slider2.splideInstance.refresh();
                }
              } else if (index === 2 && slider3) {
                if (!slider3.splideInstance) {
                  const splide3 = new Splide(slider3, {
                    type: 'slide',
                    perPage: 1.2,
                    perMove: 1,
                    arrows: false,
                    pagination: false,
                    gap: '4px',
                    focus: 'center',
                    trimSpace: false,
                  }).mount();

                  slider3.splideInstance = splide3;

                  const prevArrow3 = slider3.querySelector('.community-mobile-slider__arrow--prev');
                  const nextArrow3 = slider3.querySelector('.community-mobile-slider__arrow--next');
                  const paginationCurrent3 = slider3.querySelector('.community-mobile-slider__current');
                  const paginationTotal3 = slider3.querySelector('.community-mobile-slider__total');

                  if (prevArrow3) {
                    prevArrow3.addEventListener('click', () => splide3.go('<'));
                  }
                  if (nextArrow3) {
                    nextArrow3.addEventListener('click', () => splide3.go('>'));
                  }

                  if (paginationTotal3) {
                    const totalSlides = getSplideSlideCount(splide3);
                    paginationTotal3.textContent = String(totalSlides).padStart(2, '0');
                  }

                  splide3.on('moved', (newIndex) => {
                    if (paginationCurrent3) {
                      const currentPage = String(newIndex + 1).padStart(2, '0');
                      paginationCurrent3.textContent = currentPage;
                    }

                    if (prevArrow3) {
                      if (newIndex === 0) {
                        prevArrow3.classList.add('community-mobile-slider__arrow--disabled');
                      } else {
                        prevArrow3.classList.remove('community-mobile-slider__arrow--disabled');
                      }
                    }
                    if (nextArrow3) {
                      const totalSlides = getSplideSlideCount(splide3);
                      if (newIndex >= totalSlides - 1) {
                        nextArrow3.classList.add('community-mobile-slider__arrow--disabled');
                      } else {
                        nextArrow3.classList.remove('community-mobile-slider__arrow--disabled');
                      }
                    }
                  });
                } else {
                  slider3.splideInstance.refresh();
                }
              }
            }, 200);
          }
        }
      }

      // Add click event listeners to tab buttons
      tabButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          showTab(index);
        });
      });

      // Initialize first tab
      showTab(0);
    }
  }

  // ===============================
  // Page Flip Book
  // ===============================
  function initPageFlip(bookId, sourceId) {
    // Check if already initialized
    if (window.pageFlipInstances && window.pageFlipInstances[bookId]) {
      return window.pageFlipInstances[bookId];
    }

    const bookElement = document.getElementById(bookId);
    if (!bookElement) {
      return null;
    }

    // Check for St.PageFlip or window.St.PageFlip
    const PageFlipClass = (typeof St !== 'undefined' && St.PageFlip) 
      ? St.PageFlip 
      : (typeof window !== 'undefined' && window.St && window.St.PageFlip)
      ? window.St.PageFlip
      : null;

    if (!PageFlipClass) {
      return null;
    }

    try {
      const pageFlip = new PageFlipClass(bookElement, {
        width: 1440,
        height: 1400,
        size: "stretch",
        showCover: false,
        startPage: 1,
        flippingTime: 900,
        maxShadowOpacity: 0.6,
        useMouseEvents: true,
        disableFlipByClick: true
      });

      const sourcePages = document.querySelectorAll(`#${sourceId} .page`);
      if (sourcePages.length > 0) {
        pageFlip.loadFromHTML([...sourcePages]);
      }

      // Store instance
      if (!window.pageFlipInstances) {
        window.pageFlipInstances = {};
      }
      window.pageFlipInstances[bookId] = pageFlip;

      return pageFlip;
    } catch (error) {
      console.error(`PageFlip initialization error for ${bookId}:`, error);
      return null;
    }
  }

  function initPageFlipForTab(tabItem, tabIndex) {
    if (window.matchMedia("(max-width: 768px)").matches) {
      return;
    }

    // Wait a bit for tab to be visible
    setTimeout(() => {
      if (tabIndex === 0) {
        // First tab - book and book-source
        const pageFlip = initPageFlip("book", "book-source");
        if (!pageFlip) {
          // Retry if library not loaded
          const retryKey = `retries_book`;
          if (typeof initPageFlipForTab[retryKey] === 'undefined') {
            initPageFlipForTab[retryKey] = 0;
          }
          if (initPageFlipForTab[retryKey] < 50) {
            initPageFlipForTab[retryKey]++;
            setTimeout(() => initPageFlipForTab(tabItem, tabIndex), 100);
          }
        } else {
          // Initialize navigation for book
          initBookNavigation("book", pageFlip);
        }
      } else if (tabIndex === 1) {
        // Second tab - book-two and book-source-two
        const pageFlip = initPageFlip("book-two", "book-source-two");
        if (!pageFlip) {
          // Retry if library not loaded
          const retryKey = `retries_book-two`;
          if (typeof initPageFlipForTab[retryKey] === 'undefined') {
            initPageFlipForTab[retryKey] = 0;
          }
          if (initPageFlipForTab[retryKey] < 50) {
            initPageFlipForTab[retryKey]++;
            setTimeout(() => initPageFlipForTab(tabItem, tabIndex), 100);
          }
        } else {
          // Initialize navigation for book-two
          initBookNavigation("book-two", pageFlip);
        }
      } else if (tabIndex === 2) {
        // Third tab - book-three and book-source-three
        const pageFlip = initPageFlip("book-three", "book-source-three");
        if (!pageFlip) {
          const retryKey = `retries_book-three`;
          if (typeof initPageFlipForTab[retryKey] === 'undefined') {
            initPageFlipForTab[retryKey] = 0;
          }
          if (initPageFlipForTab[retryKey] < 50) {
            initPageFlipForTab[retryKey]++;
            setTimeout(() => initPageFlipForTab(tabItem, tabIndex), 100);
          }
        } else {
          initBookNavigation("book-three", pageFlip);
        }
      }
    }, 100);
  }

  // ===============================
  // Book Navigation Arrows
  // ===============================
  function initBookNavigation(bookId, pageFlip) {
    if (!pageFlip) return;

    const bookElement = document.getElementById(bookId);
    if (!bookElement) return;

    // Guard: only wire up listeners once per book element
    if (bookElement.dataset.navInitialized) return;
    bookElement.dataset.navInitialized = 'true';

    const navigation = bookElement.parentElement.querySelector('.book-navigation');
    if (!navigation) return;

    const prevButton = navigation.querySelector('.book-navigation__arrow--prev');
    const nextButton = navigation.querySelector('.book-navigation__arrow--next');

    if (!prevButton || !nextButton) return;

    // Function to update arrow states
    function updateArrowStates() {
      const currentPage = pageFlip.getCurrentPageIndex();
      const totalPages = pageFlip.getPageCount();

      // Disable prev button if on first page
      if (currentPage === 0) {
        prevButton.classList.add('book-navigation__arrow--disabled');
      } else {
        prevButton.classList.remove('book-navigation__arrow--disabled');
      }

      // Disable next button if on last page
      if (currentPage >= totalPages - 1) {
        nextButton.classList.add('book-navigation__arrow--disabled');
      } else {
        nextButton.classList.remove('book-navigation__arrow--disabled');
      }
    }

    // Initial state
    updateArrowStates();

    let isFlipping = false;

    // Listen for page changes
    pageFlip.on('flip', function() {
      isFlipping = false;
      updateArrowStates();
    });

    // Previous button click
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      if (isFlipping) return;
      if (!prevButton.classList.contains('book-navigation__arrow--disabled')) {
        isFlipping = true;
        pageFlip.flipPrev();
      }
    });

    // Next button click
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      if (isFlipping) return;
      if (!nextButton.classList.contains('book-navigation__arrow--disabled')) {
        isFlipping = true;
        pageFlip.flipNext();
      }
    });
  }

  // ===============================
  // Coverflow Slider
  // ===============================
  function initCoverflowSlider() {
    const sliderContainer = document.getElementById('coverflowSlider');
    if (!sliderContainer) return;

    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
      // Retry if library hasn't loaded yet
      setTimeout(initCoverflowSlider, 100);
      return;
    }

    // Check if mobile (768px breakpoint)
    const isMobile = window.innerWidth <= 768;
    const slides = sliderContainer.querySelectorAll('.swiper-slide');
    
    // Mobile: normal slider, 1 slide per view, no coverflow
    // Desktop: coverflow effect
    let swiperConfig;
    
    if (isMobile) {
      swiperConfig = {
        effect: 'slide',
        loop: true,
        grabCursor: true,
        speed: 900,
        autoplay: {
          delay: 1800,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        },
        centeredSlides: false,
        slidesPerView: 1,
        spaceBetween: 20,
        initialSlide: 0,
        on: {
          slideChange: function() {
            // Videos only play in popup, not in slider
          }
        }
      };
    } else {
      swiperConfig = {
        effect: 'coverflow',
        loop: true,
        grabCursor: true,
        speed: 900,
        autoplay: {
          delay: 1800,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        },
        centeredSlides: true,
        slidesPerView: 'auto',
        initialSlide: 0,
        coverflowEffect: {
          rotate: 20,
          stretch: 0,
          depth: 350,
          modifier: 1,
          slideShadows: true
        },
        on: {
          slideChange: function() {
            // Videos only play in popup, not in slider
          }
        }
      };
    }

    const swiper = new Swiper('#coverflowSlider', swiperConfig);

    // Videos only play in popup, not in slider

    // Get navigation arrows
    const prevArrow = sliderContainer.querySelector('.coverflow-slider__arrow--prev');
    const nextArrow = sliderContainer.querySelector('.coverflow-slider__arrow--next');
    const paginationCurrent = sliderContainer.querySelector('.coverflow-slider__current');
    const paginationTotal = sliderContainer.querySelector('.coverflow-slider__total');
    const navigationArea = sliderContainer.querySelector('.coverflow-slider__navigation');

    // Only autoplay while slider is in viewport
    if (swiper.autoplay) {
      swiper.autoplay.stop();
      const visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            swiper.autoplay.start();
          } else {
            swiper.autoplay.stop();
          }
        });
      }, {
        threshold: 0.35
      });
      visibilityObserver.observe(sliderContainer);
    }

    // Pause autoplay only when hovering navigation/button area
    if (swiper.autoplay && navigationArea) {
      navigationArea.addEventListener('mouseenter', () => {
        swiper.autoplay.stop();
      });

      navigationArea.addEventListener('mouseleave', () => {
        if (sliderContainer.getBoundingClientRect().top < window.innerHeight &&
            sliderContainer.getBoundingClientRect().bottom > 0) {
          swiper.autoplay.start();
        }
      });
    }

    // Set initial pagination total
    if (paginationTotal) {
      const totalSlides = slides.length;
      paginationTotal.textContent = String(totalSlides).padStart(2, '0');
    }

    // Add click handlers
    if (prevArrow) {
      prevArrow.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        swiper.slidePrev();
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        swiper.slideNext();
      });
    }

    // Update arrow states on slide change
    function updateArrowStates() {
      if (swiper.params.loop) {
        prevArrow?.classList.remove('coverflow-slider__arrow--disabled');
        nextArrow?.classList.remove('coverflow-slider__arrow--disabled');
        return;
      }

      if (prevArrow) {
        if (swiper.isBeginning) {
          prevArrow.classList.add('coverflow-slider__arrow--disabled');
        } else {
          prevArrow.classList.remove('coverflow-slider__arrow--disabled');
        }
      }

      if (nextArrow) {
        if (swiper.isEnd) {
          nextArrow.classList.add('coverflow-slider__arrow--disabled');
        } else {
          nextArrow.classList.remove('coverflow-slider__arrow--disabled');
        }
      }
    }

    // Listen for slide changes
    swiper.on('slideChange', function() {
      updateArrowStates();
      
      // Update pagination
      if (paginationCurrent) {
        const currentIndex = swiper.realIndex + 1;
        const currentPage = String(currentIndex).padStart(2, '0');
        paginationCurrent.textContent = currentPage;
      }
      
      // Pause all videos
      const allVideos = sliderContainer.querySelectorAll('video');
      allVideos.forEach(video => {
        video.pause();
      });
      
      // Play video in active slide
      const activeSlide = sliderContainer.querySelector('.swiper-slide-active');
      if (activeSlide) {
        const activeVideo = activeSlide.querySelector('video');
        if (activeVideo) {
          activeVideo.play().catch(() => {});
        }
      }
    });

    // Set initial state
    updateArrowStates();
    
    // Set initial pagination
    if (paginationCurrent) {
      const initialIndex = swiper.realIndex + 1;
      const initialPage = String(initialIndex).padStart(2, '0');
      paginationCurrent.textContent = initialPage;
    }
    
    // Play video in initial slide
    setTimeout(() => {
      const activeSlide = sliderContainer.querySelector('.swiper-slide-active');
      if (activeSlide) {
        const activeVideo = activeSlide.querySelector('video');
        if (activeVideo) {
          activeVideo.play().catch(() => {});
        }
      }
    }, 300);

    // Handle window resize to switch between mobile/desktop modes
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const newIsMobile = window.innerWidth <= 768;
        if (newIsMobile !== isMobile) {
          // Reinitialize slider on breakpoint change
          swiper.destroy(true, true);
          setTimeout(() => {
            initCoverflowSlider();
            // Reinitialize video modal after slider reinitializes
            setTimeout(initVideoModal, 200);
          }, 100);
        }
      }, 250);
    });

    // Initialize video modal after slider is ready
    setTimeout(initVideoModal, 300);
  }

  // Coverflow slider is below the fold — defer init until near-viewport.
  (function() {
    const coverflowEl = document.getElementById('coverflowSlider');
    if (!coverflowEl) return;
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function(entries, obs) {
        if (entries[0].isIntersecting) {
          obs.disconnect();
          initCoverflowSlider();
        }
      }, { rootMargin: '300px' });
      io.observe(coverflowEl);
    } else {
      initCoverflowSlider();
    }
  })();

  // ===============================
  // Video Modal Functionality
  // ===============================
  function initVideoModal() {
    const modal = document.getElementById('coverflowVideoModal');
    if (!modal) return;

    const modalVideo = modal.querySelector('.coverflow-slider__modal-video');
    const closeButton = modal.querySelector('.coverflow-slider__modal-close');
    const slides = document.querySelectorAll('.coverflow-slider .swiper-slide');

    if (slides.length === 0) {
      // Retry if slides aren't ready yet
      setTimeout(initVideoModal, 200);
      return;
    }

    function openVideoModal(slide) {
      const videoSrc = slide.getAttribute('data-video');
      if (videoSrc && modalVideo) {
        modalVideo.setAttribute('playsinline', '');
        modalVideo.setAttribute('webkit-playsinline', '');
        modalVideo.src = videoSrc;
        modal.classList.add('coverflow-slider__modal--active');
        document.body.classList.add('coverflow-modal-open');
        setTimeout(function() {
          if (modalVideo && modalVideo.play) {
            modalVideo.play().catch(function() {});
          }
        }, 100);
      }
    }

    // Open modal only for active slide or play button on active slide
    slides.forEach(function(slide) {
      const playButton = slide.querySelector('.coverflow-slider__play-button');
      
      // Click handler for the slide
      const slideClickHandler = function(e) {
        // Don't open modal if clicking on navigation arrows or pagination
        if (e.target.closest('.coverflow-slider__arrow') || 
            e.target.closest('.coverflow-slider__pagination')) {
          return;
        }
        
        if (!slide.classList.contains('swiper-slide-active')) {
          return;
        }

        openVideoModal(slide);
      };

      slide.addEventListener('click', slideClickHandler);

      // Also handle play button clicks (in case pointer-events is enabled)
      if (playButton) {
        playButton.addEventListener('click', function(e) {
          e.stopPropagation();
          if (!slide.classList.contains('swiper-slide-active')) {
            return;
          }

          openVideoModal(slide);
        });
      }
    });

    // Close modal
    function closeModal() {
      modal.classList.remove('coverflow-slider__modal--active');
      document.body.classList.remove('coverflow-modal-open');
      if (modalVideo) {
        modalVideo.pause();
        modalVideo.src = '';
      }
    }

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    // Close on background click
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('coverflow-slider__modal--active')) {
        closeModal();
      }
    });
  }

  // Video modal will be initialized after coverflow slider is ready

  // ===============================
  // Mobile Community Slider
  // ===============================
  function initMobileCommunitySliders() {
    // Only initialize on mobile
    if (window.innerWidth > 768) {
      return;
    }
    
    const slider1 = document.getElementById('communityMobileSlider1');
    const slider2 = document.getElementById('communityMobileSlider2');
    const slider3 = document.getElementById('communityMobileSlider3');

    if (slider1 && !slider1.splideInstance) {
      const splide1 = new Splide(slider1, {
        type: 'slide',
        perPage: 1.2,
        perMove: 1,
        arrows: false,
        pagination: false,
        gap: '4px',
        focus: 'center',
        trimSpace: false,
        breakpoints: {
          768: {
            destroy: false,
          },
        },
      }).mount();
      
      slider1.splideInstance = splide1;

      // Add custom arrow handlers
      const prevArrow1 = slider1.querySelector('.community-mobile-slider__arrow--prev');
      const nextArrow1 = slider1.querySelector('.community-mobile-slider__arrow--next');

      if (prevArrow1) {
        prevArrow1.addEventListener('click', () => splide1.go('<'));
      }
      if (nextArrow1) {
        nextArrow1.addEventListener('click', () => splide1.go('>'));
      }

      // Update arrow states and pagination
      const paginationCurrent1 = slider1.querySelector('.community-mobile-slider__current');
      const paginationTotal1 = slider1.querySelector('.community-mobile-slider__total');
      
      splide1.on('moved', (newIndex) => {
        // Update pagination
        if (paginationCurrent1) {
          const currentPage = String(newIndex + 1).padStart(2, '0');
          paginationCurrent1.textContent = currentPage;
        }
        
        if (prevArrow1) {
          if (newIndex === 0) {
            prevArrow1.classList.add('community-mobile-slider__arrow--disabled');
          } else {
            prevArrow1.classList.remove('community-mobile-slider__arrow--disabled');
          }
        }
        if (nextArrow1) {
          const totalSlides = getSplideSlideCount(splide1);
          if (newIndex >= totalSlides - 1) {
            nextArrow1.classList.add('community-mobile-slider__arrow--disabled');
          } else {
            nextArrow1.classList.remove('community-mobile-slider__arrow--disabled');
          }
        }
      });
      
      // Set initial pagination total
      if (paginationTotal1) {
        const totalSlides = getSplideSlideCount(splide1);
        paginationTotal1.textContent = String(totalSlides).padStart(2, '0');
      }
    }

    if (slider2 && !slider2.splideInstance) {
      // Initialize slider2 even if tab is hidden - it will be refreshed when tab becomes visible
      const splide2 = new Splide(slider2, {
        type: 'slide',
        perPage: 1.2,
        perMove: 1,
        arrows: false,
        pagination: false,
        gap: '4px',
        focus: 'center',
        trimSpace: false,
        breakpoints: {
          768: {
            destroy: false,
          },
        },
      }).mount();
      
      slider2.splideInstance = splide2;

      // Add custom arrow handlers
      const prevArrow2 = slider2.querySelector('.community-mobile-slider__arrow--prev');
      const nextArrow2 = slider2.querySelector('.community-mobile-slider__arrow--next');

      if (prevArrow2) {
        prevArrow2.addEventListener('click', () => splide2.go('<'));
      }
      if (nextArrow2) {
        nextArrow2.addEventListener('click', () => splide2.go('>'));
      }

      // Update arrow states and pagination
      const paginationCurrent2 = slider2.querySelector('.community-mobile-slider__current');
      const paginationTotal2 = slider2.querySelector('.community-mobile-slider__total');
      
      splide2.on('moved', (newIndex) => {
        // Update pagination
        if (paginationCurrent2) {
          const currentPage = String(newIndex + 1).padStart(2, '0');
          paginationCurrent2.textContent = currentPage;
        }
        
        if (prevArrow2) {
          if (newIndex === 0) {
            prevArrow2.classList.add('community-mobile-slider__arrow--disabled');
          } else {
            prevArrow2.classList.remove('community-mobile-slider__arrow--disabled');
          }
        }
        if (nextArrow2) {
          const totalSlides = getSplideSlideCount(splide2);
          if (newIndex >= totalSlides - 1) {
            nextArrow2.classList.add('community-mobile-slider__arrow--disabled');
          } else {
            nextArrow2.classList.remove('community-mobile-slider__arrow--disabled');
          }
        }
      });
      
      // Set initial pagination total
      if (paginationTotal2) {
        const totalSlides = getSplideSlideCount(splide2);
        paginationTotal2.textContent = String(totalSlides).padStart(2, '0');
      }
    }

    if (slider3 && !slider3.splideInstance) {
      const splide3 = new Splide(slider3, {
        type: 'slide',
        perPage: 1.2,
        perMove: 1,
        arrows: false,
        pagination: false,
        gap: '4px',
        focus: 'center',
        trimSpace: false,
        breakpoints: {
          768: {
            destroy: false,
          },
        },
      }).mount();

      slider3.splideInstance = splide3;

      const prevArrow3 = slider3.querySelector('.community-mobile-slider__arrow--prev');
      const nextArrow3 = slider3.querySelector('.community-mobile-slider__arrow--next');

      if (prevArrow3) {
        prevArrow3.addEventListener('click', () => splide3.go('<'));
      }
      if (nextArrow3) {
        nextArrow3.addEventListener('click', () => splide3.go('>'));
      }

      const paginationCurrent3 = slider3.querySelector('.community-mobile-slider__current');
      const paginationTotal3 = slider3.querySelector('.community-mobile-slider__total');

      splide3.on('moved', (newIndex) => {
        if (paginationCurrent3) {
          const currentPage = String(newIndex + 1).padStart(2, '0');
          paginationCurrent3.textContent = currentPage;
        }

        if (prevArrow3) {
          if (newIndex === 0) {
            prevArrow3.classList.add('community-mobile-slider__arrow--disabled');
          } else {
            prevArrow3.classList.remove('community-mobile-slider__arrow--disabled');
          }
        }
        if (nextArrow3) {
          const totalSlides = getSplideSlideCount(splide3);
          if (newIndex >= totalSlides - 1) {
            nextArrow3.classList.add('community-mobile-slider__arrow--disabled');
          } else {
            nextArrow3.classList.remove('community-mobile-slider__arrow--disabled');
          }
        }
      });

      if (paginationTotal3) {
        const totalSlides = getSplideSlideCount(splide3);
        paginationTotal3.textContent = String(totalSlides).padStart(2, '0');
      }
    }
  }

  // Initialize mobile sliders
  initMobileCommunitySliders();
});

// ===============================
// Community page: header auto-hide & scroll reveal
// ===============================
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var header = document.getElementById('header');
    if (!header || !document.querySelector('.banner--community')) return;

    var prefersReduced = false;
    try {
      prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (_) {}

    if (prefersReduced) {
      header.classList.add('is-visible');
      return;
    }

    document.body.classList.add('community-header-behavior');
    header.classList.add('is-visible');

    var banner = document.querySelector('.banner--community');
    var lastY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    var enabled = false;
    var ticking = false;
    var bannerDismissed = false;
    var bannerHideTimer = null;
    var AUTO_HIDE_DELAY = 1800;
    var BANNER_REHIDE_DELAY = 3000;

    function getScrollY() {
      if (window.lenis && typeof window.lenis.scroll === 'number') {
        return window.lenis.scroll;
      }
      return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function onScroll() {
      if (!ticking && enabled) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    function isInBanner() {
      if (!banner) return false;
      return getScrollY() < banner.offsetHeight;
    }

    function isAtBannerTop() {
      return getScrollY() <= 15;
    }

    function isHeaderHidden() {
      return header.classList.contains('is-hidden');
    }

    function tryRevealBannerHeader() {
      if (!enabled || !bannerDismissed || !isInBanner() || !isAtBannerTop() || isMenuOpen()) return;
      if (!isHeaderHidden()) return;
      setHeaderVisible(true);
    }

    function isMenuOpen() {
      var menu = document.querySelector('.hamburger-menu');
      return !!(menu && menu.classList.contains('is-open'));
    }

    function clearBannerHideTimer() {
      if (bannerHideTimer) {
        clearTimeout(bannerHideTimer);
        bannerHideTimer = null;
      }
    }

    function scheduleBannerHide() {
      clearBannerHideTimer();
      if (!isInBanner() || isMenuOpen()) return;

      bannerHideTimer = setTimeout(function () {
        bannerHideTimer = null;
        if (isInBanner() && !isMenuOpen()) {
          setHeaderVisible(false, true);
        }
      }, BANNER_REHIDE_DELAY);
    }

    function setHeaderVisible(visible, skipBannerTimer) {
      if (visible) {
        header.classList.remove('is-hidden');
        header.classList.add('is-visible');
        if (!skipBannerTimer && bannerDismissed && isInBanner()) {
          scheduleBannerHide();
        }
      } else {
        clearBannerHideTimer();
        header.classList.remove('is-visible');
        header.classList.add('is-hidden');
      }
    }

    setTimeout(function () {
      bannerDismissed = true;
      setHeaderVisible(false, true);
      enabled = true;
      lastY = getScrollY();
    }, AUTO_HIDE_DELAY);

    setTimeout(function () {
      if (!enabled) {
        enabled = true;
        lastY = getScrollY();
      }
    }, 1000);

    function update() {
      if (!enabled) {
        ticking = false;
        return;
      }

      var currentY = getScrollY();
      var delta = Math.abs(currentY - lastY);

      if (isMenuOpen()) {
        clearBannerHideTimer();
        setHeaderVisible(true, true);
        lastY = currentY;
        ticking = false;
        return;
      }

      if (delta < 5) {
        ticking = false;
        return;
      }

      var scrollingDown = currentY > lastY;

      if (!bannerDismissed) {
        setHeaderVisible(true, true);
        lastY = currentY;
        ticking = false;
        return;
      }

      if (!isInBanner()) {
        clearBannerHideTimer();
        var nearTop = currentY <= 50;
        var passed = currentY > 100;

        if (scrollingDown && passed && !nearTop) {
          setHeaderVisible(false, true);
        } else {
          setHeaderVisible(true, true);
        }

        lastY = currentY;
        ticking = false;
        return;
      }

      if (!scrollingDown) {
        setHeaderVisible(true);
      } else if (currentY > 30) {
        setHeaderVisible(false, true);
      }

      lastY = currentY;
      ticking = false;
    }

    if (window.lenis && typeof window.lenis.on === 'function') {
      window.lenis.on('scroll', onScroll);
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // At banner top there is nowhere to scroll up — reveal via hover, tap, or wheel-up
    var TOP_REVEAL_ZONE = 80;

    document.addEventListener('mousemove', function (e) {
      if (e.clientY > TOP_REVEAL_ZONE) return;
      tryRevealBannerHeader();
    }, { passive: true });

    window.addEventListener('wheel', function (e) {
      if (e.deltaY >= 0) return;
      tryRevealBannerHeader();
    }, { passive: true });

    if (banner) {
      banner.addEventListener('click', function (e) {
        if (e.target.closest('a, button, [role="button"]')) return;
        tryRevealBannerHeader();
      });

      banner.addEventListener('touchstart', function () {
        tryRevealBannerHeader();
      }, { passive: true });
    }
  });
})();